import {
  createConnectionApiAction,
  createConnectorAddedSuccessStep,
  createFullWidthRowLayout,
} from './connectorSchema.helpers';

export const ClaudeSchema = {
  name: 'Claude Connector',
  steps: {
    0: {
      name: 'Step 1',
      elements: [
        {
          name: 'claudeDescription',
          type: 'description',
          description:
            "Your organization's primary owner turns on the Compliance API in Claude, then creates a Compliance Access Key at Organization settings > API with only the three read scopes (do not add the delete scope), and pastes it below. Cowbell scores usage patterns, never individuals, and analyzes a sample of conversations with an AI model.",
          column: 0,
        },
        {
          name: 'complianceAccessKey',
          label: 'Compliance Access Key',
          type: 'password',
          required: true,
          column: 1,
        },
      ],
      layout: createFullWidthRowLayout(2),
      action: createConnectionApiAction(),
    },
    1: createConnectorAddedSuccessStep(
      'Claude has been successfully added as a connector. Usage data will be synced automatically.'
    ),
  },
};
